<div class="full-width-image-container">
    <img src="../../assets/AdobeStock_3558442.jpeg" alt="Header Image">
</div>

<div class="top">
    <div>Do The <span>Right Thing</span></div>
    <div>On Point <span>With Safety</span></div>
    <div>Roll up <span>Your Sleeves</span></div>
</div>
<hr class="hr">

<!-- Section 2 -->
<div class="section-container">
    <div class="links-title"><i>Field Book Number Request</i></div>
    <p class="dev-p">
        <a mat-raised-button color="primary" routerLink="/field-book-numbers">Field Book Number Request</a>
        <a mat-raised-button color="primary" routerLink="/field-book-logs">Field Book Number Look-Up</a>
    </p>
</div>

<div class="section-container">
    <div class="links-title"><i>Landpoint Contacts for RFI/RFP Help</i></div>
    <p class="dev-p">
        <a mat-raised-button color="primary" href="https://landpoint227.sharepoint.com/:x:/s/LandpointProposalManagement/IQCNjkiFCejrSKC18IaP3YEbATilHTD9FtDydRQp8KEIFXs?e=yXUsAt"
        target='_blank'>Landpoint Contacts for RFI/RFP Help</a>
    </p>
</div>

<div class="section-container">
    <div class="links-title"><i>Standards & Forms</i></div>
    <div class="sub-title">Select a category:</div>
    <p class="dev-p">
        <button mat-raised-button color="primary" routerLink="/procedures">Project & Proposals Procedures</button>
        <button mat-raised-button color="primary" routerLink="/guides">Guides & General Standards</button>
    </p>
</div>

<div class="section-container">
    <div class="links-title"><i>Proposal Templates</i></div>
    <div class="sub-title"> </div>
    <p class="dev-p">
        <a mat-raised-button color="primary" href="ms-word:ofe|u|https://landpoint227.sharepoint.com/:w:/s/LandpointProposalManagement/ESVZaC9PdyBOmKY48sTgfBoBb9uFY8AcAL0KRHv9xe8UBw?e=KRdoOT"
        target='_blank'>Outside Louisiana Proposal</a>
        <a mat-raised-button color="primary" href="ms-word:ofe|u|https://landpoint227.sharepoint.com/:w:/s/LandpointProposalManagement/ESi7c55zuFdGsO4XR6__cMEBD5yg8a3CVXMkq1sZZpVWEA?e=0qiiUd"
        target='_blank'>Inside Louisiana Proposal</a>
    </p>
    <br>
    <p class="dev-p">
        <a mat-raised-button color="primary" href="ms-word:ofe|u|https://landpoint227.sharepoint.com/:w:/s/LandpointProposalManagement/EWso6cz1g3NEsJPYufpP52cB-V4u-iO5OeXNrGPBAw4YRg?e=Vgg43I"
        target='_blank'>Standard Proposal</a>
    </p>
</div>

<div class="section-container">
    <div class="links-title"><i>Customer Contract Information</i></div>
    <div class="sub-title"></div>
    <p class="dev-p">
        <a mat-raised-button color="primary" href="https://landpoint227.sharepoint.com/:x:/s/LandpointContracts/IQCZoa1wFWN0S7j3Zh0DwprTATqMOv3Adyi2nWFMe9OxJLw"
        target='_blank'>MSA List</a>
        <a mat-raised-button color="primary" href="https://landpoint227.sharepoint.com/:x:/s/LandpointContracts/IQAx28ZU6YK-RJ56WXgWqzy1ARnEDIWL9jrrQUaOjM2o0Sc"
        target='_blank'>NDA List</a>
    </p>
    <br>
    <p class="dev-p">
        <a mat-raised-button color="primary" href="https://landpoint227.sharepoint.com/:x:/s/LandpointContracts/IQAkGVs6B9DnSKjxMQhmA1Q9Acma8ReAMLpDRCYqhzoKXqo"
        target='_blank'>Client Terms List</a>
    </p>
</div>
